<template>
  <div class="etermin-steps m-step-wrapper d-flex">
    <div class="a-step-wrapper" v-for="(step,index) in steps" :key="index" @click="MoveTo(index)" :class="getServiceStatus (index)" v-if="!step.hidden">
      <div :class="getServiceStatus (index)" class="step-btn step d-flex justify-content-between align-items-center border-radius-main position-relative">
        <div class="content d-flex align-items-center flex-grow-1 justify-content-center">
        <span class="check-field-step text-sss bg-primary rounded-lg me-0 me-md-2 me-xl-2"><font-awesome-icon class="check-icon" icon="check"/></span>
        <div class="d-flex order-xl-1 font-weight-600">
          <span class="step-order content-count">{{ Number(index+1) }}</span><span class="step-name content-text d-none d-xl-block">. {{step.name}}</span>
        </div>
        </div>
        <div class="triangle position-absolute border-radius-main"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
export default {
    name: 'steps-navigation',
    props: {
        steps: {
            type: Array,
            required: true
        }
    },
    computed: {
        ...mapGetters('etermin', ['getActiveStep']),
        ...mapGetters('etermin', ['getServiceStatus']),
        ...mapState([
            'loading',
            'selectedStore'
        ]),
        lastStepID () {
            return this.steps.length - 1
        }
    },
    methods: {
        MoveTo: function (index) {
            if (this.getActiveStep > index && this.getActiveStep !== this.lastStepID) {
                this.$store.dispatch('etermin/updateSteps', index)
            } else {
                console.log('this is not allowed')
            }
        }
    }
}
</script>

<style lang="css" scoped>

</style>
